import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  AddPassword,
  addPasswordFailed,
  addPasswordSuccess,
  requestCertificatesFailed,
  requestCertificatesSuccess,
  requestLicensesFailed,
  requestLicensesSuccess,
  requestPasswordsFailed,
  requestPasswordsSuccess,
  requestTenantsSuccess,
  requestTenantsFailed
} from '../actions/common';
import CertificateStepAPI from '../api/workflows/steps/Certificate';
import * as Constants from '../constants/action-constants';
import { AliasVmid } from '../types/Common';
import { PasswordApi, LicenseApi } from 'vrlcm-gui-api';
import { License } from 'vrlcm-gui-types';
import ProductStepAPI from '../api/workflows/steps/Product';
import { RequestTenants } from '../actions/common';

function* getPasswords() {
  try {
    const passwords = yield call(PasswordApi.getAllPasswordAliasAndVmids);
    yield put(requestPasswordsSuccess(passwords));
  } catch (error) {
    yield put(requestPasswordsFailed());
  }
}

function* getCertificates() {
  try {
    const certificates: AliasVmid[] = yield call(
      CertificateStepAPI.getCertificateAliases
    );
    yield put(requestCertificatesSuccess(certificates));
  } catch (error) {
    yield put(requestCertificatesFailed());
  }
}

function* getTenants(action: RequestTenants) {
  const {
    payload: { environmentId, productId }
  } = action;
  try {
    const availableTenants: string[] = yield call(
      ProductStepAPI.getAvailableTenants,
      environmentId,
      productId
    );
    yield put(requestTenantsSuccess(availableTenants));
  } catch (error) {
    yield put(requestTenantsFailed());
  }
}

function* getLicenses(legacyOnly?: boolean) {
  try {
    const licenses: License[] = yield call(LicenseApi.getLicenses, legacyOnly);
    yield put(requestLicensesSuccess(licenses));
  } catch (error) {
    yield put(requestLicensesFailed());
  }
}

function* watchForPasswords() {
  yield takeLatest(Constants.REQUEST_PASSWORDS, getPasswords);
}

function* watchForCertificates() {
  yield takeLatest(Constants.REQUEST_CERTIFICATES, getCertificates);
}

function* watchForTenants() {
  yield takeLatest(Constants.REQUEST_TENANTS, getTenants);
}

function* watchForLicenses() {
  yield takeLatest(Constants.REQUEST_LICENSES, getLicenses);
}

function* addPassword(action: AddPassword) {
  try {
    const { password } = action.payload;
    yield call(PasswordApi.addPassword, password);
    yield put(addPasswordSuccess(password));
  } catch (error) {
    yield put(addPasswordFailed());
  }
}

function* watchForAddPassword() {
  yield takeLatest(Constants.ADD_PASSWORD, addPassword);
}

export default function* commonSaga() {
  yield all([
    watchForPasswords(),
    watchForCertificates(),
    watchForLicenses(),
    watchForAddPassword(),
    watchForTenants()
  ]);
}
